import { constant, isPlainObject, withProperties } from "../../../utils";

function ConstantReducer(initialState) {
  return constant(initialState);
}

export default function __factory__(constants) {
  constants = isPlainObject(constants) ? constants : {};

  const REDUCERS = withProperties(
    Object.create(null),
    Object.keys(constants).reduce((mappings, key) => {
      const value = constants[key];
      mappings[key] = ConstantReducer(value == undefined ? null : value);
      return mappings;
    }, {})
  );

  return REDUCERS;
}
